export default function getFallbackValueIfNull<T>(value: T, fallback: T) {
    return value === null ? fallback : value;
}
